import { forwardRef } from "react";
import { graphql, useFragment } from "react-relay";

import type { ContentItemRenderVariantProps } from "~/components/content/content-item-render/types";
import type { magazinesStyleFashionCarouselContentItemContent$key } from "~/queries/__generated__/magazinesStyleFashionCarouselContentItemContent.graphql";

import { Backdrop, Container, Content, Cover, Title, Topic } from "./styles";

export type Props = {
  reference: magazinesStyleFashionCarouselContentItemContent$key;
} & ContentItemRenderVariantProps;

export const ContentItemStyleFashionCarousel = forwardRef<HTMLDivElement, Props>(
  ({ className, provider, reference: reference_ }, reference) => {
    const data = useFragment(
      graphql`
        fragment magazinesStyleFashionCarouselContentItemContent on Content {
          ...entityLink
        }
      `,
      reference_,
    );

    const cover = provider.coverImage({
      responsiveVariants: {
        desktopUp: "size800x1200",
        mobileUp: "size800x1200",
        tabletUp: "size800x1200",
      },
    });

    const topic = provider.topicLink?.();

    const title = provider.headline({ hideTooltip: true, preferSocialHeadline: true });

    return (
      <Container className={className} ref={reference}>
        <Topic>{topic}</Topic>
        <Cover>
          {cover}
          <Backdrop />
          <Content>
            <Title reference={data}>{title}</Title>
          </Content>
        </Cover>
      </Container>
    );
  },
);

ContentItemStyleFashionCarousel.displayName = "ContentItemStyleFashionCarousel";
